import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { checkEndorsement } from "services/Api";
import { storageData } from "services/Services";
import RenewalAlert from "components/RenewalAlert/RenewalAlert";
import useWindowSize from "utils/windowUtils";
import './Policy.css'
import { getDomain } from "services/Utils";

const Policy = (props) => {
    const [endorsementStatus, setEndorsementStatus] = useState({});
    const { idCardData, policyNumber, state, env } = props.user.userData
    const windowSize = useWindowSize;
    const isSmallDesktop = windowSize.width < 768;
    const Tkn = storageData.getItem('token')

    // First Effective Date on Policy
    const effDate = new Date(props.user.userData.boundDate);

    // Checks effective date for policy change requests availability
    useEffect(() => {
        const getStatus = async () => {
            setEndorsementStatus(await checkPendingEndorsments());
        }
        getStatus();
    }, [])

    // Renewal Effective Date
    const renewalEffectiveDt = !!idCardData[0] && 'effectivedt' in idCardData[0] ? new Date(idCardData[0].effectivedt) : effDate
    const sDate = FormatDate(renewalEffectiveDt)
    const tempDate = new Date(renewalEffectiveDt.setMonth(renewalEffectiveDt.getMonth() + 6))
    const eDate = FormatDate(tempDate)
    // const PA_TermGreaterThanOne = (state == "Pennsylvania" && policyTerm > 1)

    const checkPendingEndorsments = async () => {
        var req = {
            "policyNumber": policyNumber,
            "env": env
        }

        const response = await checkEndorsement(req);
        storageData.setItem('EndorsementStatuses', JSON.stringify(response.data));
        //console.log("responseData", response.data);

        return response.data;
    }

    return (
        <>
            <div className="d-flex align-content-center flex-column">
                <h4 className="text-center section-title">
                    MANAGE MY POLICY
                </h4>
                <div className="d-flex flex-column align-content-center mt-4 p-2 small">
                    <table className="align-content-start policy-table">
                        <tbody>
                            <tr>
                                <th>
                                    Policy Number:
                                </th>
                                <td>
                                    &nbsp;<strong>{policyNumber}</strong>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    Policy Period:
                                </th>
                                <td>
                                    &nbsp;{sDate} - {eDate}
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    <div className="mt-4 p-2">
                        <ul>
                            <Link to="/policy-id-cards"><li className="linkColors">ID Cards</li></Link>
                            <Link to="/payment-history"><li className="linkColors">View Payment History</li></Link>
                            <Link to="/documents-vault"><li className="linkColors">View Bill/Declaration Pages</li></Link>

                            <Link to="/report-claim"><li className="linkColors my-3">Report a Claim</li></Link>
                            
                            <br />
                            {/* <Link to="/change-address/landing"><li className="linkColors">Change Address</li></Link>
                            <Link to="/update-drivers/landing"><li className="linkColors">Update Drivers/Household</li></Link> */}
                            {/* {!PA_TermGreaterThanOne && */}
                                <Link to="/endorsement/add-landing">
                                    <li className="linkColors">
                                        Add Vehicle {(endorsementStatus.IsAddVehiclePending ? "(Change Pending)" : "")}
                                    </li>
                                </Link>
                            {/* } */}
                            <Link to="/endorsement/replace-landing">
                                <li className="linkColors">
                                    Replace Vehicle {(endorsementStatus.IsReplaceVehiclePending ? "(Change Pending)" : "")}
                                </li>
                            </Link>
                            <Link to="/endorsement/remove-landing">
                                <li className="linkColors">
                                    Remove Vehicle {(endorsementStatus.IsRemoveVehiclePending ? "(Change Pending)" : "")}
                                </li>
                            </Link>

                            <br />
                            <p className="text-primary address-household">
                                If you would like to update your address or make any household changes, please call us at <a href="tel:+1800-535-2873"><u>800-535-2873</u></a>.
                            </p>

                            <a href={`${getDomain()}/g/submit-documents/${state.toLowerCase().split(' ').join('-')}-pip-document-upload?tkn=${Tkn}`}><li className="linkColors">Upload Document</li></a>
                        </ul>
                    </div>
                </div>
                {(
                    !isSmallDesktop ? 
                    <div>
                        <RenewalAlert userData={props.user.userData} />
                    </div> : 
                    null
                )}
            </div>
        </>
    )
}

const FormatDate = (tempDate) => {
    var dateMonth = `${(tempDate.getMonth() + 1) < 10 ? '0' : ''}${tempDate.getMonth() + 1}`
    var dateDay = `${(tempDate.getDate() + 1) < 10 ? '0' : ''}${tempDate.getDate()}`
    var dateYear = `${tempDate.getFullYear()}`
    const date = `${dateMonth}/${dateDay}/${dateYear}`
    return date
}

export default Policy;